import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule, Location } from '@angular/common';

import { PipesModule } from '@digipay/ng-lib-pipes';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { ReactiveFormsModule } from '@angular/forms';
import { UiFormFieldBuilderModule } from '@digipay/ui-form-field-builder';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { FundDataService } from '../../../../components/core/services/fund-data.service';
import { PORTFO, RESULT_ROUTE } from '../../../../data-access/constants/app-routes';
import { environment } from '../../../../data-access/environments/environment';
import { ErrorCodes } from '../../../../data-access/enums/error-codes';
import { ErrorService } from '../../../../components/core/services/error.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PortfoService } from '../../services/portfo.service';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';
import { WalletAmountFormComponent } from '../../../wallet/components/wallet-amount-form/wallet-amount-form.component';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'wealth-applet-cash-in',
  standalone: true,
  imports: [
    CommonModule,

    PipesModule,
    NgxButtonComponent,
    ReactiveFormsModule,
    UiFormFieldBuilderModule,
    NgxAppBarComponent,
    MatTooltipModule,
    WalletAmountFormComponent,
    SpinnerComponent,
  ],
  templateUrl: './cash-in.component.html',
  styleUrl: './cash-in.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CashInComponent implements OnInit {
  balance = signal<{ balance: number; withdrawalBalance: number }>({ balance: 0, withdrawalBalance: 0 });
  isLoading = signal<boolean>(false);
  isValid = signal<boolean>(false);
  showError = signal<boolean>(false);

  private location = inject(Location);
  private errorService = inject(ErrorService);
  private portfoService = inject(PortfoService);
  private fundDataService = inject(FundDataService);
  private navigationService = inject(WealthNavigationService);
  minAmount = signal<number | undefined>(100000);
  maxAmount = signal<number | undefined>(2000000000);
  amount = signal<string | undefined>(undefined);
  ngOnInit(): void {
    this.isLoading.set(true);
    this.portfoService.getWalletInfo().subscribe((res) => {
      this.isLoading.set(false);
      if (res?.success) {
        this.balance.set({ balance: res.result?.balance, withdrawalBalance: res.result?.withdrawalBalance });
      }
    });
  }

  onBackHandler() {
    this.navigationService.navigate([PORTFO]);
  }

  amountChanged(data: { value: string; valid: boolean }) {
    this.isValid.set(data.valid);
    this.amount.set(data.value);
  }

  cashin() {
    this.isLoading.set(true);
    this.fundDataService
      .walletCashin({
        amount: this.amount(),
        callbackUrl: environment.callbackUrl,
        clientMetadata: environment.clientMetadata + '?type=CashIn',
      })
      .subscribe(
        (res) => {
          this.isLoading.set(false);
          if (res?.success) {
            const response = JSON.parse(res.result.params);
            this.location.replaceState(this.navigationService.getCurrentUrl(), `expired=true`);

            let queryParams = '';
            for (const key in response) {
              if (Object.prototype.hasOwnProperty.call(response, key)) {
                const param = response[key];
                queryParams = `${key}=${queryParams.concat(param)}&`;
              }
            }
            queryParams = queryParams.slice(0, queryParams.length - 1);
            const URL = queryParams ? res.result.url + '?' + queryParams : res.result.url;
            window.open(URL, '_self');
          } else {
            this.isLoading.set(false);
            if (res?.error?.code === ErrorCodes.orderStatusIsNotDraft) {
              this.errorService.setErrorPageExpired(false);
              this.navigationService.navigateWithQueryParams([RESULT_ROUTE], {
                queryParams: {
                  // symbol: this.state?.symbol,
                },
              });
            }
          }
        },
        () => {
          this.isLoading.set(false);
          this.navigationService.navigateWithQueryParams([RESULT_ROUTE], {
            queryParams: {
              status: 'Failed',
              action: 'cashin',
            },
          });
        },
      );
  }
}
